import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

export default function useBankList(params) {
  return useSWR(
    {
      path: "/api/v1/banks",
      method: "GET",
      params: {
        limit: 50,
        skip: 0,
        sortField: "createdAt",
        sortOrder: "asc",
        ...params,
      },
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}
